var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fin-slider',{attrs:{"value":_vm.selected - 1,"contents":_vm.contents,"card-height":278,"card-width":260,"no-word-break":""},on:{"input":function (val) { return this$1.selected = val + 1; }}})}
var staticRenderFns = []

export { render, staticRenderFns }